<script lang="ts">
	import type { Device } from 'src/types/Device';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from 'src/configs/devices';
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { ParameterCardV2 } from '@Shelly/shelly-design-system';
	import { mapIconToThin } from 'src/helpers/new-layout-helpers';
	import ControlLock from 'src/components/Controls/Single/ControlLock.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';

	export let device: Device;

	const deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = status?.online && deviceConfig ? status_configurator(status, device, settings) : [];
	$: mainLabel = Array.isArray(_statuses)
		? _statuses.find((e) => e.main !== undefined || e.name === 'state')
		: undefined;
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		{#if mainLabel}
			<ParameterCardV2
				class="mb-s"
				size="s"
				icon={mapIconToThin(mainLabel.icon)}
				iconColor={mainLabel.iconColor}
				title={capFirstChar(mainLabel.value)}
				description={capFirstChar(mainLabel.translation || '')}
			/>
		{/if}
	</div>
	<div slot="staticBottom">
		<ControlLock {device} isWide useV2Components={true} />
	</div>
</DeviceViewStateWrapper>
